/**
 * Created by kaiyan2 on 06/02/2017.
 */
import React from "react";
import {generateConfigData, generateInfoCard} from "Common/utility/infoCard"


class SampleCodeBlocks extends React.Component {

  constructor(props) {
    super(props);
    this.generateItem = this.generateItem.bind(this);
  }

  generateItem(config, index) {
    //const elements = generate(config, this.props.location, this.props.type);
    const title = config.querySelector("text").innerHTML.trim();
    const link = config.querySelector("url").innerHTML.trim();
    const target = config.querySelector("target") ? config.querySelector("target").innerHTML.trim() : "_blank";
    const description = config.querySelector("description").innerHTML;
    const language = config.querySelector("language") && config.querySelector("language").innerHTML.trim();
    const author = config.querySelector("author") && config.querySelector("author").innerHTML.trim();


    let author_el = author && <div className="pubhub-sample-code-blocks-list-item-author">
      <span>by</span>
      <span className="pubhub-sample-code-blocks-list-item-author-name">{author}</span>
    </div>;

    let language_el = language &&
      <div className="pubhub-sample-code-blocks-list-item-language"><span>{language}</span></div>;
    let title_el = <div className="pubhub-info-card-link">{title}</div>;
    let description_el = <div className="pubhub-info-card-description ">{description}</div>;

    return (
      <div key={index} className="pubhub-sample-code-blocks-list-col col-lg-4 col-md-6 col-sm-12">
        <a href={link} target={target} rel={target === '_blank' ? 'noopener noreferrer' : undefined} className="pubhub-sample-code-blocks-list-item" data-track-name="samplecode:item"
           data-track-value={title}
           data-title={title}>
          {language_el}
          {title_el}
          {author_el}
          {description_el}
        </a>
      </div>
    );
  }

  render() {
    const {config, location} = this.props;

    if (!config) {
      return <span>Loading</span>
    }

    const data = generateConfigData(config);
    const elements = generateInfoCard(data, location, this.props.type);
    const items = Array.from(config.querySelectorAll("item"));

    return (
      <div className="pubhub-sample-code-blocks pubhub-widget">
        <div className="container">
          <div className="pubhub-sample-code-blocks-title">
            {elements.title}
          </div>
          <div className="row pubhub-sample-code-blocks-list">
            {items.map(this.generateItem)}
          </div>
          <div className="pubhub-sample-code-blocks-button row justify-content-end">
            <div className="col">
              <span  data-track-name="samplecode:viewmore"
                     data-track-value={data.title} >
                {elements.link}
              </span>

            </div>

          </div>
        </div>
      </div>
    )
  }
}

export default SampleCodeBlocks;
